var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Plus"),React.createElement("g",{"id":"plus","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"+","transform":"translate(-5, -5)","fill":"#3F3F3F"},[React.createElement("polygon",{"id":"Fill-39","points":"8 16 26 16 26 18 8 18","key":0}),React.createElement("polygon",{"id":"Fill-40","points":"16 8 18 8 18 26 16 26","key":1})]))]);
}

Plus.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"};

module.exports = Plus;

Plus.default = Plus;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/common/svg/icons/plus.svg
// module id = 1504
// module chunks = 0